export const AUTH_USER_TOKEN_KEY = 'authUserTokenKey';
export const POOL_INFO_KEY = 'poolInfoKey';
export const AUTH_USER_COMPANY_NAME = 'authUserCompanyName';
export const DESIRED_PATH_LOCAL_STORE_KEY = 'desiredPath';
export const DAYS_EVENTS_STORED = 30